import axios from 'axios';
import { Environments } from 'types';
import { getUserToken } from 'helpers';
import { BRAND_PROPERTIES, ENV } from 'commons';

export const requestAxios = axios.create();

requestAxios.interceptors.request.use(
  (config: any) => {
    const { brand, accessToken } = getUserToken();

    config.baseURL = `${BRAND_PROPERTIES[brand].url[ENV]}/arezzocoocc/v2/${brand}/storesale/`;
    config.headers.authorization = `Bearer ${accessToken}`;

    return config;
  },
  (error) => {
    return Promise.reject(error).catch((error) => error);
  }
);

export const requestZendeskForm = axios.create();

requestZendeskForm.interceptors.request.use(
  (config: any) => {
    const { brand } = getUserToken();
    const {
      REACT_APP_ZENDESK_SECRET,
      REACT_APP_ZENDESK_SECRET_DEV,
      REACT_APP_ENVIRONMENT,
    } = process.env;

    const isProduction = REACT_APP_ENVIRONMENT === Environments.Prod;
    const authToken = isProduction
      ? REACT_APP_ZENDESK_SECRET
      : REACT_APP_ZENDESK_SECRET_DEV;
    const baseEnv = isProduction ? 'www' : 'dev';

    config.baseURL = `https://${baseEnv}.arezzo.com.br/api/zendesk/${brand}/`;
    config.headers.authorization = authToken;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

requestZendeskForm.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
